import React, { useState } from "react";
import ReactDOMServer from "react-dom/server";
import SVGtoPDF from "svg-to-pdfkit";
import Button from "./Button";
import { PagesEnum, cellData } from "./utils";

function SingleCell({ cell, printColors, setPage }) {
  const [name, setName] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const cellInfo = cellData[cell];

  const svgEl = React.createElement(cellInfo.element, {
    layerColors: printColors,
  });

  const createPDF = async () => {
    setIsPrinting(true);
    const svg = ReactDOMServer.renderToString(svgEl);
    const pieces = svg.split('class="cell-svg">');
    const svgCSS = `><defs><style>
        .cell-base {
          fill: inherit;
          stroke: #000000;
          stroke-width: 0.8;
        }</style></defs>`;
    const completeSVG = pieces[0] + svgCSS + pieces[1];
    const doc = new window.PDFDocument({ size: "LETTER" });
    doc.page.margins = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    };
    const center = doc.page.width / 2;
    const stream = doc.pipe(window.blobStream());
    const imageWidth = 400;
    SVGtoPDF(doc, completeSVG, center - imageWidth / 2, -140, {
      width: imageWidth,
    });
    doc.image(window.printSig, 130, 408, { width: 130 });
    doc.fontSize(12);
    doc.text(name, 220, 428, { align: "center" });
    doc.text("and", 294, 430);

    const lineWidth = 175;
    const firstStart = 108;
    const secondStart = 328;
    doc
      .moveTo(firstStart, 440)
      .lineTo(firstStart + lineWidth, 440)
      .stroke();

    doc
      .moveTo(secondStart, 440)
      .lineTo(secondStart + lineWidth, 440)
      .stroke();

    doc.end();
    stream.on("finish", function () {
      const iframe = document.createElement("iframe"); //load content in an iframe to print later
      document.body.appendChild(iframe);

      iframe.style.visibility = "hidden";
      iframe.style.position = "absolute";
      iframe.src = stream.toBlobURL("application/pdf");
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
          setIsPrinting(false);
        }, 1);
      };
    });
  };

  return (
    <div className="single-cell print-page">
      <div className="cell-editor">
        <div className="canvas">
          {svgEl}

          <div className="popup active">
            <div className="popup-option">
              <p>To print, use your browser’s print command:</p>
              <Button onClick={createPDF} disabled={isPrinting} label="Print" />
            </div>
            <div className="popup-option">
              <p>To edit your artwork, go back:</p>
              <Button
                onClick={() => {
                  setPage(PagesEnum.SINGLE);
                }}
                label="back"
              />
            </div>
            <div className="popup-option">
              <p>To return to the cell image selection menu:</p>
              <Button
                onClick={() => {
                  setPage(PagesEnum.GRID);
                }}
                label="Menu"
              />
            </div>
          </div>
        </div>
        <div className="sign-info">
          <div className="signer">
            <img
              alt="peter halley's signature"
              src="/signature_bold_small.png"
            />
          </div>
          <div className="and-spacer">
            <p>and</p>
          </div>
          <div className="signer">
            <input
              autoFocus
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleCell;
